import { useState } from 'react';
import { X } from 'lucide-react';
import { useDocumentMeta } from '../hooks/useDocumentTitle';

const GALLERY_IMAGES = [
  { url: '/gallery/project_6.jpg', title: '', description: '' },
  { url: '/gallery/project_7.jpg', title: '', description: '' },
  { url: '/gallery/project_8.jpg', title: '', description: '' },
  { url: '/gallery/project_9.jpg', title: '', description: '' },
  { url: '/gallery/project_1.jpg', title: '', description: '' },
  { url: '/gallery/project_2.jpg', title: '', description: '' },
  { url: '/gallery/project_3.jpg', title: '', description: '' },
  { url: '/gallery/project_4.jpg', title: '', description: '' },
  { url: '/gallery/project_5.jpg', title: '', description: '' }
];

export default function Gallery() {
  useDocumentMeta(
    "Project Gallery | Eastwide Electrical Services - Victoria",
    "Recent electrical projects across Victoria by Eastwide Electrical Services. LED screen installations, mains upgrades, underground wiring, and commercial maintenance work."
  );

  const [lightbox, setLightbox] = useState(null);

  return (
    <main>
      {/* Page Header */}
      <section data-testid="gallery-header" className="bg-[#3D3D3D] py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <p className="text-[#7AC943] text-sm uppercase tracking-[0.2em] font-semibold mb-4 fade-up stagger-1">Our Work</p>
          <h1 data-testid="gallery-heading" className="font-heading text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight fade-up stagger-2">
            Project Gallery
          </h1>
          <p className="text-gray-400 text-base md:text-lg max-w-xl mt-6 leading-relaxed fade-up stagger-3">
            Browse through our recent projects across Victoria.
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section data-testid="gallery-grid" className="py-20 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {GALLERY_IMAGES.map((img, i) => (
              <button
                key={i}
                data-testid={`gallery-image-${i}`}
                onClick={() => setLightbox(img)}
                className="group relative overflow-hidden rounded-lg bg-gray-100 cursor-pointer text-left"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={img.url}
                    alt={img.title || `Eastwide Electrical project ${i + 1} in Victoria`}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                {img.title && (
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <p className="text-white text-sm font-medium">{img.title}</p>
                  </div>
                )}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightbox && (
        <div
          data-testid="gallery-lightbox"
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
          onClick={() => setLightbox(null)}
        >
          <button
            data-testid="lightbox-close"
            onClick={() => setLightbox(null)}
            className="absolute top-6 right-6 text-white hover:text-[#7AC943] transition-colors"
          >
            <X size={28} />
          </button>
          <div className="max-w-4xl max-h-[85vh]" onClick={e => e.stopPropagation()}>
            <img
              src={lightbox.url}
              alt={lightbox.title || 'Eastwide Electrical project'}
              className="max-w-full max-h-[80vh] object-contain rounded-lg"
            />
            {lightbox.title && (
              <p className="text-white text-center mt-4 text-lg">{lightbox.title}</p>
            )}
          </div>
        </div>
      )}
    </main>
  );
}
